import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import legacyImages from './legacyImages';
import images from './images';

type ImageKey = keyof typeof images | keyof typeof legacyImages;

const allImages = { ...legacyImages, ...images };

registerImages('status', allImages);

declare global {
  interface RegisteredImages {
    status: Record<keyof typeof images, ImageSource | undefined>;
  }
}
